import React, { Fragment, useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { useParams, useLocation } from "react-router-dom";
import SEO from "../../components/seo";
import LayoutMain from "../../layouts/LayoutMain";
import Breadcrumb from "../../wrappers/breadcrumb/Breadcrumb";
import RelatedProductSlider from "../../wrappers/product/RelatedProductSlider";
import ProductDescriptionTab from "../../wrappers/product/ProductDescriptionTab";
import ProductImageDescription from "../../wrappers/product/ProductImageDescription";
import axios from "axios";
import { CLIENT_ID } from "../../helpers/config";
import { handleErrorRes } from "../../helpers/utils";
import useLang from "../../hooks/use-lang";
import ProductNotFound from "../../components/not-found/ProductNotFound";
import Spinner from "react-bootstrap/Spinner";
import { useTranslation } from "react-i18next";
import TagManager from 'react-gtm-module';

const Product = () => {
    let { pathname } = useLocation();
    let { id } = useParams();
    const { t } = useTranslation();
    const { products } = useSelector((state) => state.product);
    const { getLangValue } = useLang();
    // const product = products.find((product) => product.id === id);
    const [product, setProduct] = useState(null);
    const [isLoaded, setIsLoaded] = useState(false);

    const fetchProductDetail = async () => {
        try {
            let response = await axios.post(
                process.env.REACT_APP_API_URL + "/product_detail_get.php",
                {
                    client_id: CLIENT_ID,
                    product_id: id,
                }
            );

            let data = handleErrorRes(response);

            setProduct(data.product);
        } catch (err) {
            console.log(err);
        } finally {
            setIsLoaded(true);
        }
    };

    useEffect(() => {
        fetchProductDetail();
    }, [id]);

    const primary_caregory = useMemo(() => {
        if (product) {
            let primaryCat = product.categories.find(
                (c) => c.category_level === "primary"
            );

            if (!primaryCat) {
                let subCat = product.categories.find(
                    (c) => c.category_level !== "primary"
                );
                return subCat;
            }
            return primaryCat;
        } else {
            return null;
        }
    }, [product]);

    useEffect(() => {
        if (product) {
            TagManager.dataLayer({
                dataLayer: {
                    event: "product_view",
                    product: {
                        sku: product.product_sku,
                        name: product.product_name_en,
                        price: product.sale_price,
                        category: product.categories?.[0]?.category_name_en,
                    },
                }
            });
        }
    }, [product]);

    return (
        <Fragment>
            <SEO
                titleTemplate={product?.meta_title || t("product__seo_title")}
                description={product?.meta_description || t("product__seo_desc")}
                keywords={product?.meta_keywords}
            />

            <LayoutMain headerTop="visible">
                {/* breadcrumb */}
                <Breadcrumb
                    pages={[
                        {
                            label: t("home__breadcrumb"),
                            path: process.env.PUBLIC_URL + "/",
                        },
                        {
                            label: t("shop__breadcrumb"),
                            path: process.env.PUBLIC_URL + "/shop",
                        },
                        {
                            label: getLangValue(primary_caregory, 'category_name') || "",
                            path:
                                process.env.PUBLIC_URL +
                                "/shop/" +
                                primary_caregory?.id,
                        },
                    ]}
                    isLastItemActive={false}
                />

                {!isLoaded ? (
                    <div className="w-100 pt-100 pb-100 text-center">
                        <Spinner animation="border" role="status">
                            <span className="visually-hidden">
                                {t("common__loading")}...
                            </span>
                        </Spinner>
                    </div>
                ) : !!product ? (
                    <>
                        {/* product description with image */}
                        <ProductImageDescription
                            spaceTopClass="pt-50"
                            spaceBottomClass="pb-100"
                            product={product}
                        />

                        {/* product description tab */}
                        {/* <ProductDescriptionTab
                            spaceBottomClass="pb-90"
                            product={product}
                            productFullDesc={getLangValue(
                                product,
                                "product_description"
                            )}
                        /> */}

                        {/* related product slider */}
                        <RelatedProductSlider
                            spaceBottomClass="pb-95"
                            productId={id}
                        />
                    </>
                ) : (
                    <>
                        <ProductNotFound />
                    </>
                )}
            </LayoutMain>
        </Fragment>
    );
};

export default Product;
